import { FC } from "react";
import { track } from "@amplitude/analytics-browser";
import ResponsiveSheet from "@Components/ResponsiveSheet/ResponsiveSheet";
import { useJourneyDynamicDetails } from "../../context";
import ProfileIcon from "@Icons/MainIcons/ProfileIcon";
import { useTranslation } from "react-i18next";
import PassengerSummaryTrigger from "./components/PassengerSummaryTrigger/PassengerSummaryTrigger";
import PassengerSummaryContent from "./components/PassengerSummaryContent/PassengerSummaryContent";

const PassengerSummaryTitle: FC<{ numPassengers: number }> = ({ numPassengers }) => {
  const { t } = useTranslation();

  return (
    <div className="flex items-center gap-2">
      <div className="text-background-primary-active bg-background-subtle flex h-10 w-10 items-center justify-center rounded-xs">
        <ProfileIcon className="w-7 h-7"/>
      </div>
      <div className="flex flex-col">
        <div className="text-font-default text-base font-semibold">{t("Flights.details.summary.passengerDetails")}</div>
        <div className="text-font-subtle text-xs">
          {numPassengers === 1 ? t("Flights.details.summary.onePassenger") : t("Flights.details.summary.passengersCount", { count: numPassengers })}
        </div>
      </div>
    </div>
  );
};

export default function PassengerSummaryCard() {
  const { passengersState } = useJourneyDynamicDetails();
  const [passengers] = passengersState;

  const passengerItems = (passengers.passengers ?? [])
    .filter((p) => p.basicData?.firstName || p.basicData?.lastName)
    .map((p) => ({
      title: [p.basicData.title, p.basicData.firstName, p.basicData.lastName]
        .filter(Boolean)
        .map((s) => s!.charAt(0).toUpperCase() + s!.slice(1).toLowerCase())
        .join(" "),
      imgUrl: "",
    }));

  if (passengerItems.length === 0) return null;

  return (
    <ResponsiveSheet
      label={<PassengerSummaryTitle numPassengers={passengerItems.length} />}
      renderTrigger={({ open }) => (
        <PassengerSummaryTrigger
          passengerItems={passengerItems}
          onClick={() => {
            open();
            track("Opened Persons Summary", { ...passengerItems });
          }}
        />
      )}
      renderSheet={() => <PassengerSummaryContent />}
    />
  );
}
